module.exports = __webpack_public_path__ + "img/phhp-hot-water.226a506c.jpg";